import React, { Component } from 'react';

export default class SendSellerMessageModalLoader extends Component {
    state = {
        Component: null,
        mounted: false,
    };

    componentDidMount() {
        return new Promise(resolve => {
            import(/* webpackChunkName: "SendSellerMessageModal" */ './SendSellerMessageModalContainer').then(mod =>
                resolve(mod.default)
            );
        }).then(container => {
            this.setState({ Component: container, mounted: true });
        });
    }

    componentWillUnmount() {
        this.setState({ mounted: false });
    }

    render() {
        const { Component, mounted } = this.state;
        return mounted && Component !== null ? <Component /> : null;
    }
}
